'use client';

import React from 'react';
import { Box, Text, Button, Flex } from '@chakra-ui/react';
import BestSellersList from './BestSellersList';
import BestSellersListSkeleton from './BestSellersListSkeleton';
import LucideIcon from '@/components/ui/LucideIcon';
import SectionContainer from '@/components/shared/SectionContainer';
import { SafeLink } from '@/components/ui/SafeLink';
import QueryBoundary from '@/components/ui/QueryBoundary';

const BestSellersSection = () => {
  return (
    <SectionContainer
      containerWrapperProps={{
        paddingY: { base: 12, tablet: 12, desktop: 16 },
      }}
      containerInnerProps={{
        alignItems: 'stretch',
        gap: 8,
      }}
    >
      <SafeLink href="/trend/" width="100%" _hover={{ textDecoration: 'none' }}>
        <Flex
          alignItems="center"
          justify={{ base: 'space-between', tablet: 'start' }}
          width="100%"
          gap={{ base: 3, tablet: 4 }}
        >
          <Text color="neutral.100" textStyle="heading2" fontWeight="regular">
            Bestsellers
          </Text>
          <LucideIcon name="ChevronRight" boxSize={{ base: 5, tablet: 6 }} color="neutral.100" />
        </Flex>
      </SafeLink>

      <QueryBoundary loadingFallback={<BestSellersListSkeleton />}>
        <BestSellersList />
      </QueryBoundary>

      <Box textAlign="center">
        <SafeLink href="/trend/" width={{ base: 'full', tablet: '332px' }}>
          <Button
            backgroundColor="transparent"
            border="1px solid"
            borderColor="brand.50"
            borderRadius="8px"
            color="brand.50"
            textStyle="body3"
            fontWeight="regular"
            height="48px"
            padding={4}
            width={{ base: 'full', tablet: '332px' }}
            _hover={{
              backgroundColor: 'brand.50',
              color: 'common.100',
              borderColor: 'common.100',
            }}
          >
            View all
          </Button>
        </SafeLink>
      </Box>
    </SectionContainer>
  );
};

export default BestSellersSection;
